// frontend/src/constants/translations.js
/**
 * German UI text translations.
 * Centralized text strings for consistency.
 */

export const TRANSLATIONS = {
  // Common actions
  ACTIONS: {
    SAVE: 'Speichern',
    CANCEL: 'Abbrechen',
    DELETE: 'Löschen',
    EDIT: 'Bearbeiten',
    CREATE: 'Erstellen',
    UPDATE: 'Aktualisieren',
    SUBMIT: 'Absenden',
    CONFIRM: 'Bestätigen',
    CLOSE: 'Schließen',
    BACK: 'Zurück',
    NEXT: 'Weiter',
    PREVIOUS: 'Zurück',
    SEARCH: 'Suchen',
    FILTER: 'Filtern',
    EXPORT: 'Exportieren',
    IMPORT: 'Importieren',
    DOWNLOAD: 'Herunterladen',
    UPLOAD: 'Hochladen',
    PRINT: 'Drucken',
    REFRESH: 'Aktualisieren',
    ADD: 'Hinzufügen',
    REMOVE: 'Entfernen'
  },

  // Authentication
  AUTH: {
    LOGIN: 'Einloggen',
    LOGOUT: 'Abmelden',
    USERNAME: 'Nutzername',
    PASSWORD: 'Passwort',
    EMAIL: 'E-Mail',
    FORGOT_PASSWORD: 'Passwort vergessen?',
    REMEMBER_ME: 'Angemeldet bleiben',
    LOGIN_SUCCESS: 'Erfolgreich angemeldet',
    LOGIN_FAILED: 'Anmeldung fehlgeschlagen',
    LOGOUT_SUCCESS: 'Erfolgreich abgemeldet'
  },

  // Navigation
  NAV: {
    HOME: 'Start',
    DASHBOARD: 'Dashboard',
    CALENDAR: 'Kalender',
    CLIENTS: 'Klienten',
    TEAMS: 'Teams',
    REPORTS: 'Berichte',
    WORK_HOURS: 'Arbeitsstunden',
    INVOICES: 'Rechnungen',
    SETTINGS: 'Einstellungen',
    PROFILE: 'Profil',
    ADMIN: 'Admin',
    OFFICE: 'Büro',
    EMAILS: 'E-Mails'
  },

  // User roles
  ROLES: {
    ADMIN: 'Administrator',
    OFFICE: 'Büro',
    STANDARD: 'Mitarbeiter',
    DEV: 'Entwickler'
  },

  // Appointments
  APPOINTMENTS: {
    TITLE: 'Termine',
    NEW_APPOINTMENT: 'Neuer Termin',
    EDIT_APPOINTMENT: 'Termin bearbeiten',
    DELETE_APPOINTMENT: 'Termin löschen',
    APPOINTMENT_DETAILS: 'Termindetails',
    START_TIME: 'Startzeit',
    END_TIME: 'Endzeit',
    LOCATION: 'Ort',
    DESCRIPTION: 'Beschreibung',
    ASSIGNEES: 'Zugewiesen an',
    CREATOR: 'Ersteller',
    STATUS: 'Status',
    VISIBILITY: 'Sichtbarkeit',
    RECURRING: 'Wiederkehrend',
    NO_APPOINTMENTS: 'Keine Termine gefunden'
  },

  // Clients
  CLIENTS: {
    TITLE: 'Klienten',
    NEW_CLIENT: 'Neuer Klient',
    EDIT_CLIENT: 'Klient bearbeiten',
    DELETE_CLIENT: 'Klient löschen',
    CLIENT_DETAILS: 'Klientendetails',
    FIRST_NAME: 'Vorname',
    LAST_NAME: 'Nachname',
    COMPANY: 'Firma',
    PHONE: 'Telefon',
    ADDRESS: 'Adresse',
    POSTAL_CODE: 'Postleitzahl',
    CITY: 'Stadt',
    STATE: 'Bundesland',
    NOTES: 'Notizen',
    CATEGORY: 'Kategorie',
    NO_CLIENTS: 'Keine Klienten gefunden'
  },

  // Work hours
  WORK_HOURS: {
    TITLE: 'Arbeitsstunden',
    WEEK: 'Woche',
    TOTAL_HOURS: 'Gesamtstunden',
    APPOINTMENT_HOURS: 'Terminstunden',
    PREPARATION_HOURS: 'Vorbereitungsstunden',
    OFFICE_HOURS: 'Bürostunden',
    TRAVEL_HOURS: 'Reisestunden',
    STATUS: 'Status',
    SUBMIT_FOR_APPROVAL: 'Zur Genehmigung einreichen',
    APPROVE: 'Genehmigen',
    REJECT: 'Ablehnen',
    DRAFT: 'Entwurf',
    SUBMITTED: 'Eingereicht',
    APPROVED: 'Genehmigt',
    REJECTED: 'Abgelehnt'
  },

  // Invoices
  INVOICES: {
    TITLE: 'Rechnungen',
    NEW_INVOICE: 'Neue Rechnung',
    INVOICE_NUMBER: 'Rechnungsnummer',
    INVOICE_DATE: 'Rechnungsdatum',
    DUE_DATE: 'Fälligkeitsdatum',
    AMOUNT: 'Betrag',
    TAX: 'Steuer',
    TOTAL: 'Gesamt',
    PAID: 'Bezahlt',
    UNPAID: 'Unbezahlt',
    OVERDUE: 'Überfällig',
    GENERATE_PDF: 'PDF erstellen',
    SEND_INVOICE: 'Rechnung senden'
  },

  // Reports (ASB)
  REPORTS: {
    TITLE: 'Berichte',
    NEW_REPORT: 'Neuer Bericht',
    REPORT_DETAILS: 'Berichtdetails',
    ACTUAL_START_TIME: 'Tatsächliche Startzeit',
    ACTUAL_END_TIME: 'Tatsächliche Endzeit',
    PREP_TIME: 'Vorbereitungszeit',
    TRAVEL_TIME: 'Reisezeit',
    NOTES: 'Notizen',
    SIGNATURE: 'Unterschrift',
    ATTACHMENTS: 'Anhänge',
    SUBMIT_REPORT: 'Bericht einreichen'
  },

  // Common labels
  COMMON: {
    YES: 'Ja',
    NO: 'Nein',
    OK: 'OK',
    LOADING: 'Laden...',
    ERROR: 'Fehler',
    SUCCESS: 'Erfolg',
    WARNING: 'Warnung',
    INFO: 'Info',
    NAME: 'Name',
    TITLE: 'Titel',
    DATE: 'Datum',
    TIME: 'Zeit',
    FROM: 'Von',
    TO: 'Bis',
    CREATED_AT: 'Erstellt am',
    UPDATED_AT: 'Aktualisiert am',
    CREATED_BY: 'Erstellt von',
    REQUIRED: 'Erforderlich',
    OPTIONAL: 'Optional',
    ALL: 'Alle',
    NONE: 'Keine',
    SELECT: 'Auswählen',
    SELECTED: 'Ausgewählt',
    TOTAL: 'Gesamt',
    ITEMS: 'Elemente',
    PAGE: 'Seite',
    OF: 'von',
    SHOWING: 'Zeige',
    NO_RESULTS: 'Keine Ergebnisse gefunden',
    CONFIRM_DELETE: 'Möchtest du wirklich löschen?',
    UNSAVED_CHANGES: 'Nicht gespeicherte Änderungen',
    FILE: 'Datei',
    FILES: 'Dateien',
    SIZE: 'Größe',
    TYPE: 'Typ'
  },

  // Form validation
  VALIDATION: {
    REQUIRED_FIELD: 'Dieses Feld ist erforderlich',
    INVALID_EMAIL: 'Ungültige E-Mail-Adresse',
    PASSWORD_TOO_SHORT: 'Passwort muss mindestens 8 Zeichen lang sein',
    PASSWORDS_DO_NOT_MATCH: 'Passwörter stimmen nicht überein',
    INVALID_DATE: 'Ungültiges Datum',
    INVALID_TIME: 'Ungültige Zeit',
    INVALID_NUMBER: 'Ungültige Zahl',
    FILE_TOO_LARGE: 'Datei ist zu groß',
    INVALID_FILE_TYPE: 'Ungültiger Dateityp'
  },

  // Notifications
  NOTIFICATIONS: {
    TITLE: 'Benachrichtigungen',
    NO_NOTIFICATIONS: 'Keine Benachrichtigungen',
    MARK_AS_READ: 'Als gelesen markieren',
    MARK_ALL_AS_READ: 'Alle als gelesen markieren',
    DELETE_ALL: 'Alle löschen'
  },

  // Settings
  SETTINGS: {
    TITLE: 'Einstellungen',
    GENERAL: 'Allgemein',
    ACCOUNT: 'Konto',
    PREFERENCES: 'Einstellungen',
    COMPANY_INFO: 'Firmeninformationen',
    MAINTENANCE_MODE: 'Wartungsmodus'
  }
};

export default TRANSLATIONS;
